import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from './loginStaticStyles';
import LoginWorkflow from '../LoginWorkflow';

const LoginStatic = props => (
	<Modal>
		<LoginWorkflow modalMode {...props} />
	</Modal>
);

LoginStatic.propTypes = {
	outsideUsa: PropTypes.bool,
	signInHandler: PropTypes.func,
	forgotHandler: PropTypes.func,
	createAccountHandler: PropTypes.func,
};

export default LoginStatic;
